import { Action } from '@ngrx/store';
import { ClearToApply } from '../../model/ngrx/clear-to-apply.model';
import * as ClearToApplyActions from './../actions/clear-to-apply.actions';

export type Actions = ClearToApplyActions.Actions;

export function ClearToApplyReducer(state: ClearToApply[] = [], action: ClearToApplyActions.Actions) {
    switch (action.type) {
        case ClearToApplyActions.ADD_CLEAR_TO_APPLY:
            return [...state, action.payload];

        case ClearToApplyActions.REMOVE_CLEAR_TO_APPLY:
            state = [];
            return state;

        default:
            return state;
    }
}
